import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { EmailApi } from '../../api';
import Context from './index';
import { ToastContainer, toast } from "react-toastify";
import { pinagareAPIURL } from '../../Constant';

const EmailProvider = (props) => {
    const [allEmails, setAllEmails] = useState(null);
    const [singleMailRecord, setSingleMailRecord] = useState({});
    const [types, setTypes] = useState([]);
    const [type, setType] = useState('Programmes');
    const [compose, setCompose] = useState(true);
    const [isDataIn, setIsDataIn] = useState(false);

    const fetchAllEmailAsyn = async () => {
        try {
            await axios.get(`${EmailApi}`).then((resp) => {
                //setAllEmails(resp.data);
            });

        } catch (error) {
            console.log('error', error);
        }
    };

    async function pinagareFetchRequesta(url,body,eng) {
        try {
          await fetch(url, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: body,
          })
            .then((respose) => {
              if (respose.ok) {
               
                return respose.json()
              }
              throw new Error('error')
            })
            .then((data) => {
    
              
              if (data.status!=null&&data.status==true) {
    
             
                if(data.userHasApplications){//alert('Here 2');
    
                //pinagareApplications(data.tasks); 
                //console.log(JSON.stringify(data.pinagareApplications));
                setAllEmails(data.pinagareApplications);
                
    
                //toast.success("Applications fetch Successful..."); 
    
                }
                else{
    
                  //toast.error("No user applications...");
    
                }

                setIsDataIn(true);
               
                              
              } else {
    
                if (data.status!=null&&data.status==false) {
                  //toast.error(data.message);
                }
                else{
                  //toast.error("No user applications yet...");
                }
    
                           
                             
                setIsDataIn(false);
             
    
              }
            })
        } catch (error) {
         
            //toast.error("Making Data Fetch/Submit Request failed..."+JSON.stringify(error));
          
                 
            setIsDataIn(false);
         
    
        }
      }
    
    

    useEffect(() => {//alert('Here 1 '+isDataIn);

        if(!isDataIn){
    
            const body_t=JSON.stringify({
              
              omang:localStorage.getItem('username'),
              eng:'fetch_pinagare_user_applications',       
              
            });
      
            //pinagareFetchRequesta(pinagareAPIURL,body_t,'fetch_pinagare_user_applications');  
            //alert('Here 3');
          }
          //else alert('Here 1b '+isDataIn);

      //fetchAllEmailAsyn();
    }, [allEmails, types, isDataIn]);


    const groupBy = (array, f) => {
        var groups = {};
        array.forEach(function (o) {
            var group = f(o)[0];
            groups[group] = groups[group] || [];
            groups[group].push(o);
        });
        return groups;
    };

    const getAllTypes = (result) => {
        setTypes(result);
    };

    const getAllEmailsAsyn = (emails) => {
        setAllEmails(emails);
    };

    const updateType = (id) => {
        const record = allEmails.filter((rec) => rec.id === id);
        const index = allEmails.indexOf(record[0]);
        record[0].favourite = !record[0].favourite;
        setAllEmails((currEmail) => [...currEmail, (currEmail[index] = record[0])]);
        axios.put(`${EmailApi}/${id}`, record[0]);
    };

    return (
        <Context.Provider
            value={{
                ...props,
                allEmails,
                types,
                type,
                singleMailRecord,
                compose,
                isDataIn,
                setCompose: setCompose,
                setSingleMailRecord: setSingleMailRecord,
                setType: setType,
                groupBy: groupBy,
                getAllType: getAllTypes,
                updateType: updateType,
                getAllEmailsAsyn: getAllEmailsAsyn,
                pinagareFetchRequestas: pinagareFetchRequesta,
                setIsDataIn: setIsDataIn,
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default EmailProvider;
